import { Box, Typography, TypographyOwnProps } from '@mui/material';
import { format } from 'date-fns/format';
import { useTranslation } from 'react-i18next';
import { Maybe } from '@kheops/graphql';
import { longDateFormat } from '../../../common/state/state';

interface ProductLastModificationDatesProps {
  titleVariant?: TypographyOwnProps['variant'];
  last_price_updated_date?: Maybe<string>;
  last_other_updated_date?: Maybe<string>;
}

export default function ProductLastModificationDates({ titleVariant, last_price_updated_date, last_other_updated_date }: ProductLastModificationDatesProps): React.JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant={titleVariant}>{t('common:last_modifications')}</Typography>
      {last_price_updated_date && (
        <>
          <Box
            sx={{
              display: 'flex',
              mt: 1,
              mb: 0.5,
            }}
          >
            <Typography variant="bodySmall">
              {t('common:prices')}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
            }}
          >
            <Typography variant="bodyMedium">
              {format(last_price_updated_date, longDateFormat)}
            </Typography>
          </Box>
        </>
      )}

      {last_other_updated_date && (
        <>
          <Box
            sx={{
              display: 'flex',
              mt: 1,
              mb: 0.5,
            }}
          >
            <Typography variant="bodySmall">
              {t('common:others')}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
            }}
          >
            <Typography variant="bodyMedium">
              {format(last_other_updated_date, longDateFormat)}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
